import { useStorage } from './useStorageFallback';

export function useSessionStorage(key, defaultValue, opts) {
  return useStorage('session', key, defaultValue, opts);
}
